<template>
    <div v-show="show">
        <div class="px-4 py-5 sm:p-6 uppercase">
            <h3 class="text-2xl text-gray-300 text-center py-10">
                <slot></slot>
            </h3>
        </div>
    </div>
</template>

<script>

export default {
    name: "NoResults",

    props: {
        show: {
            required: true
        }
    }
}

</script>
